import React from "react";
import Select from "./select";

export default (props) => (
    <Select {...{ ...props, isMulti: true, closeMenuOnSelect: false }} />
);
